'use client';

import { AppErrorView } from '@/components/error/AppErrorView';
import { paperlogy } from '@/styles/fonts/paperlogy';
import './globals.css';

type GlobalErrorPageProps = {
  error: Error & { digest?: string };
  unstable_retry: () => void;
};

/**
 * 루트 레이아웃 오류까지 대체해 렌더링하는 최상위 오류 화면입니다.
 */
export default function GlobalErrorPage({ unstable_retry }: GlobalErrorPageProps) {
  return (
    <html lang="ko" className={paperlogy.variable} data-scroll-behavior="smooth">
      <body className="min-h-screen bg-(--color-app-bg) text-(--color-app-text) antialiased">
        <AppErrorView
          actions={[
            { label: '다시 시도', onClick: unstable_retry, variant: 'primary' },
            { href: '/', label: '처음 화면으로', variant: 'secondary' },
            { href: '/login', label: '로그인 화면', variant: 'secondary' },
          ]}
          code="오류"
          description="서비스 초기화 중 문제가 발생했습니다. 다시 시도해도 같은 문제가 반복되면 관리자에게 문의해 주세요."
          documentTitle="서비스를 표시하지 못했습니다"
          eyebrow="시스템 오류 안내"
          title="서비스를 표시하지 못했습니다."
        />
      </body>
    </html>
  );
}
